/* eslint-disable no-use-before-define */
import type { InferGetStaticPropsType } from "next";
import { NextSeo } from "next-seo";

import { Breadcrumbs, Layout } from "~/components/common";
import { BlockTips } from "~/components/common/homepage/block_tips";
import { BlogArticle } from "~/components/blog/single-card";
import { BlogDataType } from "~/types";

export default function BlogSinglePage({
  article,
}: //   recommendedArticles,
InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <NextSeo
        title={article.yoast_head_json.title}
        description={article.yoast_head_json.og_description}
        openGraph={{
          title: article.yoast_head_json.og_title,
          description: article.yoast_head_json.og_description,
          url: process.env.NEXT_PUBLIC_FRONTEND_URL,
          type: article.yoast_head_json.og_type,
          locale: article.yoast_head_json.og_locale,
          site_name: article.yoast_head_json.og_site_name,
          article: {
            publishedTime: article.yoast_head_json.article_published_time,
            modifiedTime: article.yoast_head_json.article_modified_time,
            tags: article.tags,
          },
        }}
        robotsProps={{
          maxSnippet: article.yoast_head_json.robots["max-snippet"],
          maxImagePreview: article.yoast_head_json.robots["max-image-preview"],
          maxVideoPreview: article.yoast_head_json.robots["max-video-preview"],
        }}
      />
      <Layout>
        <div className="mx-auto px-8">
          <Breadcrumbs isAbsolute />
        </div>
        <BlogArticle article={article} />
        {/* <BlockTips articles={recommendedArticles} /> */}
      </Layout>
    </>
  );
}

export async function getStaticProps(props: any) {
  try {
    const { params } = props;
    const { slug } = params;

    const endpoint = process.env.WORDPRESS_ENDPOINT;

    const response = await fetch(
      `${endpoint}/wp-json/wp/v2/blogposts?slug=${slug}&_embed`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    return {
      props: {
        article: data[0],
        //   recommendedArticles: recommendedArticlesCombinedData,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching post:", error);
    return {
      notFound: true,
    };
  }
}

export async function getStaticPaths() {
  try {
    const endpoint = process.env.WORDPRESS_ENDPOINT;

    const response = await fetch(
      `${endpoint}/wp-json/wp/v2/blogposts/?_embedded`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response?.json();

    const postData = data?.map((item: BlogDataType) => {
      const slug = item.slug;
      return {
        params: {
          slug,
        },
      };
    });

    return {
      paths: postData,
      fallback: false,
    };
  } catch (error) {
    return {
      paths: [],
      fallback: false,
    };
  }
}
